import Link from 'next/link';
import { MenuItem } from './menuItem';
import SidebarNav from './sidebarNav';

const SidebarItem = ({ title, link, newTab, sub_menu, closeSidebar }: MenuItem & { closeSidebar: () => void }) => {
  return (
    <>
      {sub_menu ? (
        <SidebarNav menu={{ title, link, newTab, sub_menu }} closeSidebar={closeSidebar} />
      ) : (
        <li className="px-3 border-b border-dashed border-slate-300">
          <Link
            prefetch={false}
            href={link ?? '#'}
            className="block py-3 font-light"
            title={title}
            target={newTab ? '_blank' : undefined}
            rel={newTab ? 'noopener noreferrer' : undefined}
            onClick={closeSidebar}
          >
            {title}
          </Link>
        </li>
      )}
    </>
  );
};

export default SidebarItem;
